// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SUNO3iL3E2Y0r_xEYSt1{display:flex;align-items:center;gap:8px}.L14PGOZXirv0ge8YMvGV{margin-left:0px}`, "",{"version":3,"sources":["webpack://./src/entities/Billing/ui/AddPaymentMethodModal/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CAGF,sBACE,eAAA","sourcesContent":[".checkboxRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.primaryTooltip {\n  margin-left: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxRow": `SUNO3iL3E2Y0r_xEYSt1`,
	"primaryTooltip": `L14PGOZXirv0ge8YMvGV`
};
export default ___CSS_LOADER_EXPORT___;
